import * as Types from './types';
import { IJackpotTickerData } from '../../types';

export const getAmount = (
    { date, tickerData, interval }: Types.IUpdateTickerDataParams
): Partial<IJackpotTickerData> => {
    const { step, amount, originAmount, amountStartTime } = tickerData;
    const timeDiff = date - amountStartTime;
    const newAmount = amount + (timeDiff / interval * step || 0);

    if (originAmount <= newAmount) {
        return {
            amount: originAmount,
            isLimitReached: true
        };
    }

    if (timeDiff >= interval && amount !== newAmount) {
        return {
            amount: newAmount,
            amountStartTime: date
        };
    }

    return {};
};

export const getCountdownTimer = (
    { date, tickerData }: Omit<Types.IUpdateTickerDataParams, 'interval'>
): Partial<IJackpotTickerData> => {
    let { tempHitTime } = tickerData;
    const { showHitTime, hitTimeStartTime, changeTypeStartTime } = tickerData;

    if (!tempHitTime) {
        return {};
    }

    // if hitTime reach limit
    if (tempHitTime < 1000) {
        return {
            isHitTimeEnded: true,
            isLimitReached: true,
            showHitTime: false
        };
    }

    // Change hitTime every sec if timer is visible
    if (showHitTime && date - hitTimeStartTime >= 1000) {
        tempHitTime -= date - hitTimeStartTime;

        return {
            tempHitTime,
            hitTime: tempHitTime,
            hitTimeStartTime: date
        };
    }

    // Change visibility of timer every 5 sec
    if (date - changeTypeStartTime >= 5000) {
        return {
            changeTypeStartTime: date,
            showHitTime: !showHitTime
        };
    }

    return {};
};
